import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 3",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M18.3999 0.179199H1.5999C0.939902 0.179199 0.399902 0.718526 0.399902 1.38969C0.399902 2.06085 0.939902 2.60018 1.5999 2.60018H18.3999C19.0599 2.60018 19.5999 2.06085 19.5999 1.38969C19.5999 0.718526 19.0599 0.179199 18.3999 0.179199Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }